{
  "fontSizeXXXXL": "64px",
  "fontSizeXXXL": "44px",
  "fontSizeXXL": "24px",
  "fontSizeXL": "19px",
  "fontSizeLarge": "16px",
  "fontSizeMedium": "14px",
  "fontSizeSmall": "12px",
  "fontSizeXS": "12px",
  "fontFamilyPrimary": "'Apercu Pro', 'Helvetica Neue', 'Helvetica', 'Tahoma', 'Geneva', 'Arial', sans-serif",
  "fontFamilyMono": "'Apercu Mono', 'Lucida Console', 'Monaco', 'Courier New', 'Courier', monospace"
}
